import { render } from "./BuildProperty.vue?vue&type=template&id=0581e486&scoped=true"
import script from "./BuildProperty.vue?vue&type=script&lang=js"
export * from "./BuildProperty.vue?vue&type=script&lang=js"

import "./BuildProperty.vue?vue&type=style&index=0&id=0581e486&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0581e486"]])

export default __exports__